import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full h-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex m-auto"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-10 w-10 m-auto text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col px-4 py-5 w-full"
}
const _hoisted_6 = { class: "flex flex-col space-y-3 w-full pb-8 w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex text-white text-lg font-medium" }, "Upcoming", -1)
const _hoisted_8 = {
  key: 1,
  class: "p-3 bg-brand-dark-gray text-brand-light-gray rounded-lg w-full text-center"
}
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col space-y-3 w-full pb-8"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex text-white text-lg font-medium" }, "Waiting for host to accept invite", -1)
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col space-y-3 w-full pb-8"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex text-white text-lg font-medium" }, "Interested", -1)
const _hoisted_13 = {
  key: 2,
  class: "flex flex-col space-y-3 w-full pb-8"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex text-white text-lg font-medium" }, "Past", -1)

import {onMounted, ref, Ref} from "vue";
import {EventInterface} from "@/interfaces/EventInterface";
import ApiService from "@/services/api/apiService";
import {EventFilterIs} from "@/definitions/EventFilterIs";
import EventCard from "@/components/EventCard.vue";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {useIonRouter} from "@ionic/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventsMyTickets',
  emits: ['onEventTapped'],
  setup(__props, { emit: __emit }) {


const emit = __emit

const upcoming: Ref<EventInterface[]> = ref([])
const interested: Ref<EventInterface[]> = ref([])
const requested: Ref<EventInterface[]> = ref([])
const past: Ref<EventInterface[]> = ref([])

const loading = ref(true)
const observer = ref()
const authUser = ref()

onMounted(async () => {
  await getData()
  authUser.value = await ApiService.User().authUser()
  loading.value = false

  observer.value = Observable.subscribe(async (response: any) => {
    if (response.event === (
        ObservableEvent.PullToRefreshMyTickets ||
        ObservableEvent.EventsScrollTop
    )) {
      await pullToRefresh(response.data)
    }
  })

})

const pullToRefresh = async (ev?: any) => {
  await getData()
  Observable.emit(ObservableEvent.PendingEventResponsesChanged)
  if (ev) ev.target.complete()
}

const getData = async () => {

  const data = await Promise.all([
    await ApiService.Events().all(EventFilterIs.Attending),
    await ApiService.Events().all(EventFilterIs.Interested),
    await ApiService.Events().all(EventFilterIs.InviteRequested),
    await ApiService.Events().all(EventFilterIs.Attended)
  ])

  upcoming.value = data[0]
  interested.value = data[1]
  requested.value = data[2]
  past.value = data[3]
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (upcoming.value.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(upcoming.value, (event) => {
                  return (_openBlock(), _createBlock(EventCard, {
                    onClick: ($event: any) => (emit('onEventTapped', event)),
                    layout: "list",
                    event: event,
                    "with-context-menu": event.organiser.id === authUser.value.id,
                    key: event.id
                  }, null, 8, ["onClick", "event", "with-context-menu"]))
                }), 128))
              : _createCommentVNode("", true),
            (!upcoming.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " You aren't attending any upcoming events. "))
              : _createCommentVNode("", true)
          ]),
          (requested.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requested.value, (event) => {
                  return (_openBlock(), _createBlock(EventCard, {
                    onClick: ($event: any) => (emit('onEventTapped', event)),
                    layout: "list",
                    event: event,
                    "with-context-menu": event.organiser.id === authUser.value.id,
                    key: event.id
                  }, null, 8, ["onClick", "event", "with-context-menu"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (interested.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interested.value, (event) => {
                  return (_openBlock(), _createBlock(EventCard, {
                    onClick: ($event: any) => (emit('onEventTapped', event)),
                    layout: "list",
                    event: event,
                    "with-context-menu": event.organiser.id === authUser.value.id,
                    key: event.id
                  }, null, 8, ["onClick", "event", "with-context-menu"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (past.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(past.value, (event) => {
                  return (_openBlock(), _createBlock(EventCard, {
                    onClick: ($event: any) => (emit('onEventTapped', event)),
                    layout: "list",
                    event: event,
                    "with-context-menu": event.organiser.id === authUser.value.id,
                    key: event.id
                  }, null, 8, ["onClick", "event", "with-context-menu"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})